import axios from '@/utils/request'
var Qs = require('qs')

export default {

	// 2021-11-18
	create(params) {
		return axios.post('/customer-addresses', params)
	},
	//  2021-11-18
	update(id, params) {
		return axios.put('/customer-addresses/' + id, params)
	},

	//  2021-11-18
	delete(id) {
		return axios.delete('/customer-addresses/' + id)
	},

}

